import { forwardRef } from 'react'
import { SuffixInput, type SuffixInputProps } from './SuffixInput'

const percentageFormatter = new Intl.NumberFormat('de-DE', {
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
})

const formatPercentage = (value: number | undefined | null): string => {
  if (value === undefined || value === null || isNaN(value)) {
    return ''
  }
  return percentageFormatter.format(value)
}

const parsePercentage = (value: string): number | undefined => {
  if (!value || value.trim() === '') {
    return undefined
  }

  const cleaned = value.replace(/\./g, '').replace(/,/g, '.')

  const parsed = parseFloat(cleaned)
  if (isNaN(parsed)) {
    return undefined
  }

  return parsed
}

export interface PercentageInputProps
  extends Omit<SuffixInputProps, 'suffix' | 'formatValue' | 'parseValue'> {}

export const PercentageInput = forwardRef<HTMLInputElement, PercentageInputProps>(
  ({ value, onChange, onBlur, className, ...props }, ref) => {
    return (
      <SuffixInput
        {...props}
        ref={ref}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        className={className}
        suffix="%"
        formatValue={formatPercentage}
        parseValue={parsePercentage}
      />
    )
  }
)

PercentageInput.displayName = 'PercentageInput'
